export default {
  identityInit(state, user) {
    state.user = user;
  },
  identityError(state, error) {
    state.error = error;
  },
  userLoaded(state, user) {
    state.user = user;
  },
  userUnloaded(state) {
    state.user = null;
  },
  accessTokenExpiring() {},
  accessTokenExpired(state) {
    state.user = null;
  },
  silentRenewError(state, error) {
    state.error = error;
  },
  userSignedOut() {
    // TODO: fix sign-in redirect hell in safari and chrome incognito
    // state.user = null;
  }
};
